import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import {
  PRICE_SCHEDULE_MODES,
  LEGACY_SCREEN_VIEW, NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { screenInfo, formFields } from "./TrOOPScheduleFormConfig";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import { useModal } from "../../common_nextgen/hooks/ModalContext";
import useLookupNavigation from "../../common_nextgen/common_components/common-hooks/useLookupNavigation";

const TroopScheduleForm = ({ mode, selectMode, selectedCode, hideModal }) => {
  const { TROOP_SCHEDULE, TROOP_SCHEDULE_STEP } = ROUTE_PATHS;

  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  /* const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);*/
  const [stateVal, setStateVal] = useState(location.state || []);
  const { previousState, currentState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    //console.log("current state in form", currentState, previousState);

    return { previousState, currentState };
  }, [stateVal]);
  /*const {
    selectedSchedules = [],
    previousScreen = TROOP_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = currentState;*/
  const {
    selectedSchedules,
    previousScreen,
    initialIndex,
    initialExternalMode,
    initialLookupType,
    lookupParams,
    lookupScreen,
    navigateData,
    lookupMode: initialLookupMode = false,
    formData: baseFormData = {},
    currentMode: initialCurrentMode = mode,
    dataDrafted: initialDataDrafted = false,
  } = useMemo(() => {
    let {
      selectedSchedules = [],
      previousScreen = "/",
      currentIndex: initialIndex = 0,
      lookupType: initialLookupType,
      externalMode: initialExternalMode = false,
      lookupMode,
      lookupParams,
      lookupScreen,
      navigateData,
      formData,
      currentMode,
      dataDrafted,
    } = currentState;
    return {
      selectedSchedules,
      previousScreen,
      initialIndex,
      initialExternalMode,
      initialLookupType,
      lookupMode,
      lookupParams,
      lookupScreen,
      navigateData,
      formData,
      currentMode,
      dataDrafted,
    };
  }, [currentState]);
  const navigateToPage = useCustomNavigate();
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(initialCurrentMode);
  // const [selectMode,setSelectMode]=useState(initialSelectMode);
  const [initialFormData, setInitialFormData] = useState(baseFormData);
  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  const [dataDrafted, setDataDrafted] = useState(initialDataDrafted);
  const toast = useToast();

  /*const { showModal } = useModal();
  const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(lookupScreen, { params }, handleReceiveData, formData);
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    if (viewType === "legacy") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        acc[item["legacy"]] = formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      showModal(lookupScreen, { params }, null, formData, true);
    }
  };
  */
  /*
  initialLookupMode,
  lookupParams,
  previousState,
  currentState,
  initialIndex,
  initialFormData,
  lookupScreen = {},
  navigateData,
  currentMode,
   */

  useEffect(() => {
    const hasBaseFormData = baseFormData && Object.keys(baseFormData).length;
    if (
      hasBaseFormData &&
      JSON.stringify(initialFormData) !== JSON.stringify(baseFormData)
    ) {
      setInitialFormData(baseFormData);
    }
  }, [baseFormData]);

  const {
    lookupData,
    fetchLookupData,
    viewLookupDetails,
    lookupMode,
    setLookupMode,
  } = useLookupNavigation({
    currentState,
    previousState,
    initialLookupMode,
    navigateData,
    lookupParams,
    lookupScreen,
    initialIndex,
    currentMode,
    initialFormData,
  });

  const lastScheduleName =
    selectedSchedules[currentIndex]?.tscScheduleName || "";
  const updatedParamsData = {
    ...currentState.paramsData,
    tscScheduleName: lastScheduleName,
    hiddenRecordIndicator: "Active",
  };

  const handleBack = () => {
    if (externalMode) {
      const message = {
        message: "navigate-to-external-program",
        url: previousScreen,
        parameters: {
          state: [...previousState],
        },
      };
      console.log("back messages", message);
      window.parent.postMessage(message, "*");
    } else if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setLookupMode(false);
      setCurrentMode(mode);
      setInitialFormData({});
      setDataDrafted(false);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = () => {
    const [screenTitle, screenNumber] = isAddMode(mode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/tscTroopScheduleCtl";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/tscTroopScheduleCtl";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData) &&
        !dataDrafted
      ) {
        infoChanged = false;
      }
    }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
       if (responseStatus.message === NO_CHANGE_OF_INFO) {
                               toast.current.show({
                                 severity: "info",
                                 summary: "",
                                 detail: responseStatus.message,
                                 life: 3000,
                               });
                             } else {
                               toast.current.show({
                                 severity: "success",
                                 summary: "",
                                 detail: responseStatus.message,
                                 life: 3000,
                               });
      //setInitialFormData(responseData);
      // setDataDrafted(false);
      //setLookupMode(false);
      if (isAddMode(currentMode)) {
        // setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
        const updatedCurrentState = {
          ...currentState,
          selectedSchedules: [{ ...responseData }],
          currentIndex: 0,
          currentMode: PRICE_SCHEDULE_MODES.EDIT,
          lookupMode: false,
          formData: {},
          dataDrafted: false,
        };
        const lastRecord = previousState.pop() || {};
        const addedParamsData = {
          tscScheduleName: responseData?.tscScheduleName,
          hiddenRecordIndicator: "Active",
        };
        /* setStateVal([
          ...previousState,
          { ...lastRecord, paramsData: addedParamsData },
          updatedCurrentState,
        ]);*/
        navigateToPage(ROUTE_PATHS.TROOP_SCHEDULE_EDIT, [
          ...previousState,
          { ...lastRecord, paramsData: addedParamsData },
          updatedCurrentState,
        ]);
      } else {
        setDataDrafted(false);
        setInitialFormData(responseData);
      }
    }} catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};
    if (selectMode) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => {
        setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
        setLookupMode(false);
      };
      keyName.chmod = "View";
      keyFunc.F7 = () =>
        navigateToPage(TROOP_SCHEDULE_STEP, [
          ...previousState,
          { ...currentState, currentIndex, externalMode, lookupMode },
          {
            selectedSchedules: [initialFormData],
            currentIndex: 0,
            previousScreen: location.pathname,
          },
        ]);
      keyName.F7 = "Steps";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
      keyFunc.F7 = () =>
        navigateToPage(TROOP_SCHEDULE_STEP, [
          ...previousState,
          { ...currentState, currentIndex, externalMode, lookupMode },
          {
            selectedSchedules: [initialFormData],
            currentIndex: 0,
            previousScreen: location.pathname,
          },
        ]);
      keyName.F7 = "Steps";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, initialFormData, externalMode, lookupMode]);

  useEffect(() => {
    const fetchInitialData = async () => {
      let url = isAddMode(currentMode)
        ? `api/tscTroopScheduleCtl/initialFormData/${encodeURIComponent(
            screenInfo.ADD[1]
          )}`
        : `api/tscTroopScheduleCtl/${encodeURIComponent(
            selectMode
              ? selectedCode[0]?.tscScheduleName
              : selectedSchedules[currentIndex]?.tscScheduleName
          )}`;
      try {
        const { responseData } = await axios_helper_no_header("GET", url);
        setInitialFormData(responseData);
      } catch (e) {
        console.error(e);
      }
    };

    /* if (
      isAddMode(currentMode) ||
      selectedCode?.length ||
      selectedSchedules?.length
    )
      fetchInitialData();
    */
    if (!Object.keys(initialFormData).length) {
      fetchInitialData();
    }
  }, [mode, currentIndex, selectedCode, selectedSchedules, initialFormData]);

  const handleMessage = (event) => {
    const { type, data } = event.data;
    if (type === "set-params") {
      setStateVal(data);
      setExternalMode(true);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div className={`grid container ${selectMode ? "popup" : ""}`}>
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          fetchLookupData={fetchLookupData}
          lookupData={lookupData}
          viewLookupDetails={viewLookupDetails}
        />
      </div>
    </div>
  );
};

export default TroopScheduleForm;
